import { render, staticRenderFns } from "./CbsObjectImport.vue?vue&type=template&id=d9bc67d8&scoped=true"
import script from "./CbsObjectImport.vue?vue&type=script&lang=js"
export * from "./CbsObjectImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bc67d8",
  null
  
)

export default component.exports